/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/19 16:01
 * @Description 园区用地
 */

export default {
  name: "breadcrumbNavDataStore",
  state: [],
  addData(name, path,query) {
    this.state.push({ name, path ,query});
    sessionStorage.setItem(this.name, JSON.stringify(this.state.slice(0, -1)));
  },
  removeData(index) {
    this.state.splice(index);
    sessionStorage.setItem(this.name, JSON.stringify(this.state.slice(0, -1)));
  },
  getData() {
    if (this.state?.length) {
    } else {
      let data = JSON.parse(sessionStorage.getItem(this.name));
      if (data?.length) {
        this.state.push(...data);
      }
    }
    // console.log("get", this.state);
    return this.state;
  },
};
